import React, { useState } from 'react';
import { ReactComponent as ProjectsIcon } from './icons/projects.svg';
import { ReactComponent as TariffIcon } from './icons/tariff.svg';
import { ReactComponent as UsersIcon } from './icons/users.svg';
import { ReactComponent as PricesIcon } from './icons/prices.svg';
import { ReactComponent as WindowsIcon } from './icons/windows.svg';
import './header.scss';
import useGlobal from '../../../store';
import { useLocation, useNavigate } from 'react-router-dom';

const Header = () => {

  const [ isMenuOpened, setIsMenuOpened ] = useState( false );
  
  return (

    <header className = "header flex justify-between items-center">

      <div className="header__logo">3D Балкон</div>

      { window.location.pathname !== "/signin" && 
      
        <div

          className="header__burger" 
          onClick = { () => setIsMenuOpened( !isMenuOpened ) } 

        /> 
        
      }

      { isMenuOpened && <HeaderMenu close = { () => setIsMenuOpened( false ) } /> }

    </header>

  );

}

const HeaderMenu = ({ close }) => {

  const [ globalState ] = useGlobal();
  const { user_id, user_role } = globalState;
  const navigate = useNavigate();
  const location = useLocation();

  const MENU = [
    {
      icon: <ProjectsIcon />,
      path: "/",
      text: "Балконы и статистика"
    }
       
  ]

  if ( user_id ) {

    MENU.push({

      icon: <TariffIcon />,
      path: "/tariff",
      text: "Мой тариф"

    });

  }

  if ( user_role !== 3 ) {

    MENU.push({

      icon: <UsersIcon />,
      path: "/team",
      text: "Мои сотрудники"

    });

  }

  if ( Number( user_role ) === 1 || Number( user_role ) === 2 ) {

    MENU.push({

      icon: <PricesIcon />,
      path: "/prices",
      text: "Настроить цены"

    });

  }

  // MENU.push({

  //   icon: <WindowsIcon />,
  //   path: "/windows_partners",
  //   text: "Мои поставщики окон"
    
  // });

  return (

    <div className = "header__menu">

      { MENU.map(({ icon, path, text }, key) => (

        <div 
          key = { key }
          className = "header__menu__row flex items-center"
          onClick = { () => {

            close();
            if ( location.pathname !== path ) navigate( path );

          }}
        >

          { icon }
          { text }

        </div>

      ))}      

    </div>

  );

}

export default Header;